module.exports = __webpack_public_path__ + "img/a5-s8.635fc873.jpg";